import { useDeploymentSetConfig } from './useDeploymentSetConfig'

export function useGasSettings() {
  const gasBaseURL = useDeploymentSetConfig().v3BackendLrtUrl
  return { gasBaseURL }
}
